import React, { Component } from 'react';
import { useState } from 'react';
import TabComponent from '../TabComponent';
import DatePicker from '../DatePicker';
import TimePicker from '../TimePicker';
import Calendar from '../Calendar';
import { withStore } from '../store';
import EventAttendees from './EventAttendees';
import EventPictures from './EventPictures';
import MultiDropDown from '../MultiDropDown/MultiDropDown';
import { Service } from '../ApiService';
import Status from '../Status';
import Alert from '../Alert';
import { alertNotValid, showMessage } from '../alerts'
import StatusDraftSVG from '../../svg/StatusDraftSVG';
import StatusPublishedSVG from '../../svg/StatusPublishedSVG';
import StatusCanceledSVG from '../../svg/StatusCanceledSVG';
import Loader from '../Loader';
import eventValidators from './eventValidators'
import InputWithClearButton from '../InputWithClearButton';
import EventCalendar from './EventCalendar';
import { Helper } from '../Helper';
import ToggleButton from 'react-toggle-button';

import StatusDeletedSVG from '../../svg/StatusDeletedSVG';

import DeleteUpSVG from '../../svg/DeleteUpSVG'
import SaveUpSVG from '../../svg/SaveUpSVG'
import ReturnUpSVG from '../../svg/ReturnUpSVG'
import CheckBox from '../CheckBox';
import EventServices from './EventServices';



class Event extends Component {

    constructor(props) {
        super(props);
        props.store.refreshUserInfo();
        let evtId = 0;
        if (props.match.params.id) {
            evtId = props.match.params.id
        }
        this.state = {
            repeatedEventsIsOpen: true,
            activeTabIndex: 0,
            members: [],
            pictures: [],
            loading: evtId != 0,
            eventTypes: [],
            baseEvent: {
                name: "",
                description: "",
                eventType: 0,
                site: 0,
                dates: [],
                type: null,
                groupId: 0,
                eventStatus: "draft",
                gracePricePeriod: 21
            },
            eventMain: {
                name: "",
                description: "",
                eventType: 0,
                site: 0,
                dates: [],
                type:null,
                groupId: 0,
                eventStatus: "draft",
                gracePricePeriod: 21
            },
            useGracePricePeriod: false,
            eventId: evtId,
            showError: false,
            showDialog: false,
            showMessage: false,
            showPromptDialog: false,
        };
        this.dayDropDownRef = null;
        this.numberDropDownRef = null;

        //this.chaptersDropDownRef = null;
        this.typeOfEventDropDownRef = null;
        this.nextStep = this.nextStep.bind(this);
        this.updateEvent = this.updateEvent.bind(this);
        this.fixMainEventData = this.fixMainEventData.bind(this);
        this.updateEventProperty = this.updateEventProperty.bind(this);
        this.setActiveStep = this.setActiveStep.bind(this);
        this.onSaveClick = this.onSaveClick.bind(this);
        this.emptyTitle = false;
        this.emptyChapter = false;
        this.emptyStartDate = false;

        this.emptyType = false;
        this.headerText = '';
    }

    hidePopups = () => {
        this.setState({
            showCustomError: false,
            showError: false,
            showDialog: false,
            showMessage: false,
            showPromptDialog: false
        })
    }

    componentWillMount(){
        this.validators = eventValidators();
        this.alertNotValid = alertNotValid(() => this.setState({ showError: false }));
    }

    componentWillReceiveProps(props) {
        this.setDefaultChapter(props);
    }

    setDefaultChapter(props) {
        if (props.store.userInfo != null && this.state.eventId == 0 && props.store.userInfo.authType == "Secretary") {
            var temp = this.state.eventMain;
            temp.site = props.store.userInfo.chapterId;
            this.setState({ eventMain: temp });
        }
    }

    componentDidMount() {
        Service.getEventTypesActiveOnly().then(data => this.setState({ eventTypes: data }));

        this.setDefaultChapter(this.props);
        if (this.props.location && this.props.location.state && this.props.location.state.date) {
            var temp = this.state.eventMain;
            temp.date = this.props.location.state.date;
            this.setState({ eventMain: temp });
        }
        var component = this;
        if (this.state.eventId != 0) {
            Service.getEvent(this.state.eventId)
                .then(data => {
                    var fixedData = component.fixMainEventData(data);

                    component.setState({
                        eventMain: { ...fixedData },
                        baseEvent: { ...fixedData },
                        useGracePricePeriod: data.gracePricePeriod > 0,
                        loading: false
                    });
                })
                .catch(exception => component.setState({ error: exception, loading: false }));
        }
    }
    
    fixMainEventData(data) {
        data.dates.forEach(day => day.date = new Date(day.date));
        //data.timeFrom["activated"] = true;
        //data.timeTo["activated"] = true;
        return data;
    }

    updateEvent = () => {
        var event = Object.assign({}, this.state.eventMain);

        if (!this.checkEventChanges()) {
            return Promise.resolve(event);
        }

        event.id = this.state.eventId;
        this.setState({ loading: true });
        return Service.changeEvent(event)
            .then(data => {
                if (data.success === false) {
                    this.headerText = 'Failure';
                    this.dialogText = "Unable to save event";
                    this.dialogContent = <h4>{data.message}</h4>
                    this.mode = 'error'
                    this.setState({ loading: false, showMessage: true });
                    return Promise.reject(new Error(data.message));
                }
                else if (data.success === true) {
                    return data.data;
                }
                else return data;
            });
    }

    checkEventChanges = () => {
        var baseEvent = this.state.baseEvent;
        var changedEvent = this.state.eventMain;
        var hasChanges = false;

        var properties = Object.getOwnPropertyNames(baseEvent);
        properties.map(property => {
            if (Array.isArray(baseEvent[property])) {
                if (baseEvent[property].length !== changedEvent[property].length) {
                    hasChanges = true;
                    return false;
                }

                for (var i = 0; i < baseEvent[property].length; i++) {
                    if (Helper.CompareDates(baseEvent[property][i].date, changedEvent[property][i].date) != 0) {
                        hasChanges = true;
                        return false;
                    }
                }
            }
            else {
                if (baseEvent[property] != changedEvent[property]) {
                    hasChanges = true;
                    return false;
                }
            }
            return false;
        });

        return hasChanges;
    }

    onSaveClick = () => {
        let save = () => {
            this.updateEvent().then((data) => {
                /* SHOW SUCCESS MESSAGE */
                this.headerText = 'Success';
                this.dialogText = "Information was successfully saved for the event";
                this.dialogContent = <h4>{this.state.eventMain.name}</h4>
                this.mode = 'success'
                this.setState({
                    loading: false,
                    showMessage: true,
                    baseEvent: {...this.state.eventMain }
                });
            }, (reason) => {
                    console.log(reason);
            })/*.catch((reason) => {

                this.headerText = 'Failure';
                this.dialogText = "Unable to save event";
                this.dialogContent = <h4>{reason}</h4>
                this.mode = 'error'
                this.setState({ loading: false, showMessage: true });

                console.log(reason);// show Error Window 
            })*/
        }
        this.performIfValid(() => save(), () => this.setState({ showError: true }));
    } 

    setActiveStep(num) {
        var me = this;
        var afterStep = (data) => {
            me.setState({
                activeTabIndex: num,
                eventId: data.id,
                loading: false,
                baseEvent: { ...data }
            });
        }

        if (num == 1) {
            afterStep = (data) => {
                Service.getEventAttendees(data.id)
                    .then(attendees => {
                        setTimeout(() => {
                            me.setState({
                                activeTabIndex: num,
                                members: attendees,
                                eventId: data.id,
                                loading: false,
                                baseEvent: { ...data }
                            });
                        }, 500);
                    })
                    .catch(err => { alert(err) });
            }
        }

        let updateEvent = () => {
            this.updateEvent().then((data) => {
                if (data)
                    afterStep(this.fixMainEventData(data));
            }, (rejection) => {
                    console.log(rejection);
            });
        }

        switch (this.state.activeTabIndex) {
            case 0:
                updateEvent();
                break;
            case 2:
                var me = this;
                updateEvent();
                break;
            default:
                this.setState({ activeTabIndex: num });
        }
    }


    nextStep() {
        this.setActiveStep(this.state.activeTabIndex + 1);
    }

    onTestChange(newVal){
        var tmp = this.state.eventMain;
        tmp.test = newVal;
        this.setState({eventMain:tmp});
    }

    toggleRepeatedEvents(){
        this.setState({repeatedEventsIsOpen: !this.state.repeatedEventsIsOpen});
    }

    formatImageList(pageNumber) {
        let rowHeight = this.state.rowHeight;
        let maxWidth = this.imageGalleryRef.getBoundingClientRect().width;
        let newArray = [];
        let newImageList = [];
        let totalWidth = 0;
        let counter = 0;
        let tryUntill = 0;
        let imageList = this.state.pictures;
        if (pageNumber*this.state.amountPerPage < imageList.length) {
            tryUntill = pageNumber*this.state.amountPerPage;
        }
        else tryUntill = imageList.length;
        for (let i=(pageNumber-1)*this.state.amountPerPage; i < tryUntill; i++) {
            totalWidth = totalWidth + (imageList[i].width * rowHeight) / imageList[i].height;
            counter = counter + 1;
            newArray.push(imageList[i]);
            if (totalWidth > maxWidth) {
                for (let j=0; j < newArray.length; j++){
                    newArray[j].flexBasis = (((newArray[j].width * rowHeight)/newArray[j].height) /totalWidth)*100*(1 - (10*(counter-1))/maxWidth);
                }
                newImageList.push(newArray);
                counter=0;
                totalWidth = 0;
                newArray = []; 
            }
        }
        if (newArray.length > 0) {
            for (let j=0; j < newArray.length; j++){
                newArray[j].flexBasis = (((newArray[j].width * rowHeight)/newArray[j].height) /maxWidth)*100*(1 - (10*(counter-1))/maxWidth);
            }
            newImageList.push(newArray);
        }
        this.setState(() => ({formattedPicturesList: newImageList}));
    }

    updateEventProperty(property, value, comparator) {
        var temp = {...this.state.eventMain};
        if (Array.isArray(temp[property])) {
            let arr = [...temp[property]];
            var foundIndex = arr.findIndex(dt => {
                if (comparator && typeof comparator === 'function') {
                    return comparator(dt, value);
                }
                else {
                    return dt === value;
                }
            });
            if (foundIndex >= 0) {
                arr.splice(foundIndex, 1);
            }
            else {
                arr.push(value);
            }
            temp[property] = arr;
        }
        else {
            temp[property] = value;
        }
        this.setState({ eventMain: temp });
    }

    onPublishButtonClick() {
        let onOkButtonClick = () => {
            let event = this.state.eventMain;
            event.eventStatus = 'published';
            this.updateEvent().then(data => {
                this.setState({ eventMain: this.fixMainEventData(data), showDialog: false, loading: false });
            });
        };
        let publish = () => {
            this.headerText = 'Publish';
            this.onOkButtonClick = onOkButtonClick;
            this.dialogText = "Are you sure you want to publish event?";
            this.dialogContent = <h4>{this.state.eventMain.name}</h4>
            this.setState({showDialog: true});
        }
        this.performIfValid(() => publish(), () => this.setState({showError: true}) );
    }

    onCancelEventButtonClick() {
        let onOkButtonClick = () => {
            let event = this.state.eventMain;
            event.eventStatus = 'canceled';
            this.updateEvent().then(data => {
                this.setState({ eventMain: this.fixMainEventData(data), showDialog: false, loading:false });
            });
            
        };
        let cancel = () => {
            this.headerText = 'Cancel';
            this.onOkButtonClick = onOkButtonClick;
            this.dialogText = "Are you sure you want to cancel event?";
            this.dialogContent = <h4>{this.state.eventMain.name}</h4>
            this.setState({showDialog: true});
        }
        this.performIfValid(() => cancel(), () => this.setState({showError: true}) );
    }

    onDeleteEventButtonClick() {
        let onOkButtonClick = () => {
            let event = this.state.eventMain;
            event.eventStatus = 'deleted';
            this.setState({ loading:true });
            this.updateEvent().then(data => {
                this.setState({ 
                    eventMain: this.fixMainEventData(data), 
                    showDialog: false, 
                    /*loading:false */
                }, () => this.props.history.goBack());
            });
        };
        let del = () => {
            this.headerText = 'Delete';
            this.onOkButtonClick = onOkButtonClick;
            this.dialogText = "Are you sure you want to delete the event?";
            this.dialogContent = <div><h4>{this.state.eventMain.name}</h4><p className='m-05'>This action can not be undone. Delete anyway?</p></div>
            this.setState({showDialog: true});
        }
        let checkIfEventHasID = () => {
            if(this.state.eventId === 0){this.props.history.goBack()}
            else del();
        }
        this.performIfValid(() => del(), checkIfEventHasID);
    }

    onMoveToDraftsButtonClick() {
        let onOkButtonClick = () => {
            let event = this.state.eventMain;
            event.eventStatus = 'draft';
            this.updateEvent().then(data => {
                this.setState({ eventMain: this.fixMainEventData(data), showDialog: false, loading: false });
            });
        };
        let draft = () => {
            this.headerText = 'Move to drafts';
            this.onOkButtonClick = onOkButtonClick;
            this.dialogText = "Are you sure you want to move the event to drafts?";
            this.dialogContent = <h4>{this.state.eventMain.name}</h4>
            this.setState({showDialog: true});
        }
        this.performIfValid(() => draft(), () => this.setState({showError: true}) );
    }

    renderHeader() {
        if (this.props.match.path == '/new-event') {
            return (<h1 className='uppercase-text mb-2'>New<strong> Event</strong></h1>)
        } else {
            return (<h1 className='uppercase-text mb-2'>Edit<strong> Event</strong></h1>)
        }
    }

    performIfValid(callback, errorCallback) {
        if (this.props.store.isFormValid(this.validators, this.state.eventMain)) {
            callback()
        } 
        else { 
            if (errorCallback) { errorCallback()} 
        };
    }

    onSetDayTimesClick(dayIndex) {
        let date = this.state.eventMain.dates[dayIndex];

        const updateTempTime = (from, to, callback) => {
            var temp = { ...this.state.eventMain };
            temp.tempTimeFrom = from;
            temp.tempTimeTo = to;
            this.setState({ eventMain: temp }, () => {
                if (callback) callback();
            });
        }

        updateTempTime(date.timeFrom, date.timeTo, () => {

            let onOkButtonClick = () => {
                var temp = { ...this.state.eventMain };

                var dates = [...this.state.eventMain.dates];
                let date = dates[dayIndex];
                date.timeFrom = this.state.eventMain.tempTimeFrom;
                date.timeTo = this.state.eventMain.tempTimeTo;
                temp["dates"] = dates;
                this.setState({ eventMain: temp, showPromptDialog: false });
            };

            this.headerText = 'Please pick event time period';
            this.dialogText = "";
            this.onOkButtonClick = onOkButtonClick;

            this.setState({ showPromptDialog: true });
        });
    }

    getTabToRender = () => {
        switch (this.state.activeTabIndex) {
            case 0: return this.getMainTab();
            case 1: return this.getAttendeesTab();
            case 2: return this.getServicesTab();
            case 3: return this.getPicturesTab();
            default: return '';
        }
    }

    getMainTab = () => {
        var me = this;
        const user = this.props.store.userInfo;
        const date = new Date();
        return <ul className='input-fields first-child-text-125 mt-1 pl-1 pr-1'>
            <li>
                <p>Event Title:</p>
                <div className={this.props.store.checkIfShowError('name', this.validators) ? 'error-input-wrapper' : ''}>
                    <InputWithClearButton
                        type='text'
                        placeholder='Event Title'
                        value={this.state.eventMain.name}
                        onChange={e => {
                            this.updateEventProperty("name", e.target.value)
                            this.props.store.updateValidators("name", e.target.value, this.validators);
                        }}
                        onClearValue={() => {
                            this.updateEventProperty("name", "");
                            this.props.store.updateValidators("name", "", this.validators);
                        }}
                    />
                    {this.props.store.displayValidationErrors('name', this.validators)}
                </div>
            </li>
            {/*<li>
                <p>Chapter:</p>
                <div className={this.props.store.checkIfShowError('site', this.validators) ? 'error-input-wrapper' : ""}>
                    <MultiDropDown
                        ref={el => this.chaptersDropDownRef = el}
                        list={this.props.store.chapterList.filter(a => !a.deleted)}
                        multiSelect={false}
                        keyProperty='id'
                        textProperty='state'
                        expandBy='chapters'
                        expandedTextProperty='name'
                        expandedKeyProperty='id'
                        expandedMultiSelect={false}
                        defaultValue={this.state.eventMain.site}
                        placeholder="Select chapter"
                        disabled={!(user && user.authType == "Admin")}
                        onDropDownValueChange={value => {
                            this.props.store.updateValidators("site", value, this.validators);
                            this.updateEventProperty("site", value);
                        }}
                    />
                    {this.props.store.displayValidationErrors('site', this.validators)}
                </div>
            </li>*/}

            <li
                className={this.emptyStartDate ? 'mark-invalid' : ''}
                error-text='Please enter the date range'
            >
                <p>Dates:</p>
                <div className={this.props.store.checkIfShowError('dates', this.validators) ? 'error-input-wrapper' : ""}>
                    <EventCalendar
                        useTime={false}
                        dates={this.state.eventMain.dates}
                        ref={el => this.eventCalendarRef = el}
                        minDate={date.setFullYear(date.getFullYear() - 1) }
                        onSetDayTimesClick={this.onSetDayTimesClick.bind(this)}
                        onSelect={date => {
                            this.emptyStartDate = false;
                            this.props.store.updateValidators("dates", date, this.validators);
                            var newObj = {
                                date: date,
                                timeFrom: {
                                    activated: false,
                                    hours: 8,
                                    minutes: 0,
                                    am: true,
                                },
                                timeTo: {
                                    activated: false,
                                    hours: 10,
                                    minutes: 0,
                                    am: true,
                                },
                            };
                            this.updateEventProperty("dates", newObj, (obj1, obj2) => Helper.AreDatesEqual(obj1.date, obj2.date));
                        }}
                    />
                    {this.props.store.displayValidationErrors('date', this.validators)}
                </div>
            </li>

            <li
                className={this.emptyType ? 'mark-invalid' : ''}
                error-text='Please select the Event Type'
            >
                <p>Type of event:</p>
                <div className={this.props.store.checkIfShowError('eventType', this.validators) ? 'error-input-wrapper' : ""}>
                    <MultiDropDown
                        ref={el => this.typeOfEventDropDownRef = el}
                        list={this.state.eventTypes}
                        keyProperty='id'
                        textProperty='title'
                        defaultValue={this.state.eventMain.eventType}
                        placeholder='Event type'
                        onDropDownValueChange={value => {
                            this.emptyType = false;
                            this.props.store.updateValidators("eventType", value, this.validators);
                            this.updateEventProperty("eventType", value)
                        }}
                    />
                    {this.props.store.displayValidationErrors('eventType', this.validators)}
                </div>
            </li>
            {/*<li className='marginContent'>
                <p>Use grace price period:</p>
                <ToggleButton style={{ 'margin-top': '10px' }}
                    value={!this.state.useGracePricePeriod}
                    thumbStyle={{ borderRadius: 2 }}
                    trackStyle={{ borderRadius: 2 }}
                    onToggle={(value) => {
                        me.setState("useGracePricePeriod", value);
                    }} />

            </li>*/}
            <li /*hidden={!this.state.useGracePricePeriod}*/>
                <p>Grace price period (days):</p>
                <div style={{ display: 'flex' }}>
                    <input type='number' className='mr-1' //style={{ maxWidth: '3rem' }}
                        step="1"
                        min='0'
                        max='100'
                    //disabled={!this.state.useGracePricePeriod}
                    value={this.state.eventMain.gracePricePeriod}
                    onChange={(e) => {
                        this.updateEventProperty('gracePricePeriod', e.target.value);
                    }}
                    />
                    {/*<span className='mr-1'>Discount (%):</span>
                    <input type='number' style={{ maxWidth: '3rem' }}
                        min='0'
                        max='100'
                        //disabled={!this.state.useGracePricePeriod}
                        //value={this.state.eventMain.gracePricePeriod}
                        onChange={(e) => {
                            //this.updateEventProperty('gracePricePeriod', e.target.value);
                        }}
                    />
                    */}
                </div>
            </li>

            <li>
                <p className='mark-optional'>Description:</p>
                <div className='input-button-wrapper'>
                    <textarea
                        ref={el => this.descriptionInputRef = el}
                        placeholder='Description'
                        value={this.state.eventMain.description}
                        onChange={(evt) => this.updateEventProperty("description", evt.target.value)}
                    />
                </div>
            </li>
        </ul>
    }

    getAttendeesTab = () => {
        const user = this.props.store.userInfo;
        return <EventAttendees eventId={this.state.eventId} attendees={this.state.members} />
    }

    getServicesTab = () => {
        const user = this.props.store.userInfo;
        return <EventServices
            eventId={this.state.eventId}
            gracePricePeriod={this.state.eventMain.gracePricePeriod}
            editsPermitted={user && (user.authType == "Secretary" || user.authType == "Admin")} // && this.state.eventMain.dates.filter((elem) => elem.date > new Date()).length > 0}
        />
        
        {/*          return <EventBudget 
                        eventId={this.state.eventId} 
                        projectedCost={this.state.eventMain.projectedCost} 
                        onProjectedCostChange={value => this.updateEventProperty("projectedCost", value)}
                    />*/}
    }

    getPicturesTab = () => {
        return <EventPictures eventId={this.state.eventId} />
    }

    render() {
        const user = this.props.store.userInfo;
        let eventStatus = this.state.eventMain.eventStatus;
        if (eventStatus === undefined) {eventStatus = "draft"}
        //const pictures = this.state.formattedPicturesList;

        let tabToRender = this.getTabToRender();

        return (
            <div className='pages-wsm-wrapper ipw-800'>
                <div className='second-nav-wrapper'>
                    <div className='ipw-600'>
                        <div className = 'flex-nowrap align-center'>
                            <Status eventStatus={eventStatus} className='mr-025' />
                            {eventStatus !== 'published' && eventStatus !== 'deleted' &&
                                <button 
                                    className='round-button medium-round-button outline-on-hover hlo500' 
                                    onClick = {() => this.onPublishButtonClick()}
                                    hint = 'Publish'
                                >
                                    <StatusPublishedSVG />
                                    <span>Publish</span>
                                </button>
                            }
                            {eventStatus !== 'canceled' && eventStatus !== 'deleted' && user &&
                                <button 
                                    className='round-button medium-round-button outline-on-hover hlo500' 
                                    onClick = {() => this.onCancelEventButtonClick()}
                                    hint = "Cancel"
                                >
                                    <StatusCanceledSVG />
                                    <span>Cancel</span>
                                </button>
                            }
                            {eventStatus !== 'canceled' && eventStatus !== 'draft' && eventStatus !== 'deleted' && user &&
                                <button 
                                    className='round-button medium-round-button outline-on-hover hlo500'
                                    onClick = {() => this.onMoveToDraftsButtonClick()}
                                    hint = "Draft"
                                >
                                    <StatusDraftSVG />
                                    <span>Draft</span>
                                </button>
                            }
                        </div>
                        <div className='flex-nowrap align-center'>
                            {eventStatus !== 'deleted' && user &&
                                <button 
                                    className='round-button medium-round-button outline-on-hover hlo500'
                                    onClick = {() => this.onDeleteEventButtonClick()}
                                    hint="Delete"
                                >
                                    <DeleteUpSVG />
                                    <span>Delete</span>
                                </button>
                            }
                            {user &&
                                <button
                                    className='round-button medium-round-button outline-on-hover hlo500'
                                    hint="Save"
                                    onClick={this.onSaveClick}
                                >
                                    <SaveUpSVG />
                                    <span>Save</span>
                                </button>
                            }
                            <button
                                className='round-button medium-round-button outline-on-hover hlo500'
                                hint="Exit"
                                onClick={() => this.props.history.goBack()}
                            >
                                <ReturnUpSVG />
                                <span>Exit</span>
                            </button>
                        </div>
                    </div>
                </div>
                {this.state.loading && <Loader/>}
                {this.renderHeader()}
                <div className = 'flex-wrap flex-flow-column mb-3'>
                    <TabComponent 
                        fixedHeight={true}
                        tabList={['information', 'attendees', 'services', 'pictures']}
                        wasSelected={(index) => this.performIfValid(() => this.setActiveStep(index), () => this.setState({showError: true}) )}
                        activeTabIndex={this.state.activeTabIndex}
                    />
                </div>

                {tabToRender}

                <div className='flex-wrap mt-2'>
                    {this.state.activeTabIndex > 0 &&
                        <button 
                            className='medium-static-button static-button' 
                            onClick={() => this.performIfValid(() => this.setActiveStep(this.state.activeTabIndex-1), () => this.setState({showError: true}) )}
                        >Back</button>
                    }
                    {this.state.activeTabIndex < 3 &&
                        <button 
                            className='medium-static-button static-button default-button' 
                            onClick={() => this.performIfValid(this.nextStep, () => this.setState({showError: true})) }
                        >Next</button>
                    }
                </div>
                
                {this.state.showError && this.alertNotValid}

                {this.state.showPromptDialog &&
                    <Alert
                        headerText={this.headerText}
                        text={this.dialogText}
                        onClose={() => this.setState({ showDialog: false })}
                        showOkCancelButtons={true}
                        onCancelButtonClick={() => this.setState({ showDialog: false })}
                        onOkButtonClick={() => this.onOkButtonClick()}
                        cancelButtonText="Cancel"
                        okButtonText="Ok"
                        mode='warning'
                    >
                    <div>
                        <TimePicker
                            //ref={timeFromPicker}
                            timePickerMode={true}
                            value={this.state.eventMain.tempTimeFrom}
                            style={{ fontSize: "0.8rem" }}
                            onChange={(time) => {

                                //if (value.activated) { this.emptyTimeFrom = false; }
                                //this.props.store.updateValidators("timeFrom", value, this.validators);
                                this.updateEventProperty("tempTimeFrom", time);

                                //updateTempTime(time, this.state.eventMain.tempTimeTo);

                                //timeFromPicker.current.setValueManually(time);
                                //this.props.store.updateValidators("timeFrom", value, this.validators);
                                //this.updateEventProperty("timeFrom", time);

                            }}
                        />
                        <TimePicker
                            //ref={timeToPicker}
                            timePickerMode={true}
                            value={this.state.eventMain.tempTimeTo}
                            style={{ fontSize: "0.8rem" }}
                            onChange={(time) => {
                                this.updateEventProperty("tempTimeTo", time);

                                //updateTempTime(this.state.eventMain.tempTimeFrom, time);
                                //this.state.eventMain.tempTimeTo = time;
                                //timeFromPicker.current.setValueManually(time);
                            }}
                        />
                        {/*<button text="OK" onClick={() => { }} />
                        //onOkButtonClick(timeFromPicker.current.value, timeToPicker.current.value)} />*/}
                    </div>
                    </Alert>
                }

                {this.state.showDialog && 
                    <Alert 
                        headerText = {this.headerText}
                        text = {this.dialogText}
                        onClose = {() => this.setState({showDialog: false})}
                        showOkCancelButtons = {true}
                        onCancelButtonClick = {() => this.setState({showDialog: false})}
                        onOkButtonClick = {() => this.onOkButtonClick()}
                        cancelButtonText = "Cancel"
                        okButtonText = "Ok"
                        mode = 'warning'
                    >
                       {this.dialogContent}
                    </Alert>
                }

                {this.state.showMessage && showMessage(this.headerText, this.dialogText, this.dialogContent, this.mode, () => this.setState({ showMessage: false }))}


                {/*this.state.showMessage && 
                    <Alert 
                        headerText = {this.headerText}
                        text = {this.dialogText}
                        onClose = {() => this.setState({showMessage: false})}
                        showOkButton = {true}
                        onOkButtonClick = {() => this.setState({showMessage: false})}
                        okButtonText = "Ok"
                        mode = {this.mode}
                    >
                       {this.dialogContent}
                    </Alert>
                */}
            </div>
        );
    }
}

export default withStore(Event);


// WEBPACK FOOTER //
// ./src/components/event/Event.jsx